import BaseService from './BaseService'

const COMPANY = 'COMPANY'

class ProspectingCommonService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  getAgencySettings = (companyId: string) => this.requests.get(`/settings/entities/${COMPANY}/${companyId}`)
}

const prospectingCommonService = new ProspectingCommonService(BaseService.servicesConfig.Prospecting as string)

export default prospectingCommonService
